import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress ResizeObserver errors (benign warnings from Radix UI components)
// These errors occur during dropdown/popover animations and are harmless
if (typeof window !== 'undefined') {
  // Suppress via window.onerror
  const originalOnError = window.onerror;
  window.onerror = (message, source, lineno, colno, error) => {
    if (message && typeof message === 'string' && message.includes('ResizeObserver')) {
      return true; // Prevents the error from propagating
    }
    if (originalOnError) {
      return originalOnError(message, source, lineno, colno, error);
    }
    return false;
  };

  // Suppress via error event listener
  window.addEventListener('error', (e) => {
    if (e.message && e.message.includes('ResizeObserver')) {
      e.stopImmediatePropagation();
      e.preventDefault();
      return true;
    }
  }, true);

  // Suppress via unhandledrejection (for promise-based errors)
  window.addEventListener('unhandledrejection', (e) => {
    if (e.reason && e.reason.message && e.reason.message.includes('ResizeObserver')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return true;
    }
  }, true);

  // Patch ResizeObserver to prevent the error from being thrown in the first place
  const resizeObserverErr = window.ResizeObserver;
  if (resizeObserverErr) {
    window.ResizeObserver = class ResizeObserver extends resizeObserverErr {
      constructor(callback) {
        super((entries, observer) => {
          // Use requestAnimationFrame to batch updates and prevent loop errors
          window.requestAnimationFrame(() => {
            callback(entries, observer);
          });
        });
      }
    };
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
